import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { environment } from 'environments/environment';

import { User } from './user.class';

import { Observable } from 'rxjs/Observable';

const BASE_PATH = '/ws/app/user';
const BASE_URL = `${environment.API_URL}${BASE_PATH}`;

@Injectable()
export class UserService {

  constructor(
    public http: HttpClient
  ) {}

  public get(id): Observable<User> {
    return this.http.get(`${BASE_URL}/${id}`)
      .map((userData) => new User(userData));
  }

  public create(user: User): Observable<User> {
    return this.http.post(BASE_URL, user)
      .map((userData) => new User(userData));
  }

  public update(id: string, user: User): Observable<any> {
    return this.http.put(`${BASE_URL}/${id}`, user);
  }

  public remove(id: string): Observable<any> {
    return this.http.delete(`${BASE_URL}/${id}`);
  }

  public all(): Observable<User[]> {
    return this.http.get(BASE_URL)
      .map((listUserData) =>
        (listUserData as any[]).map((userData) => new User(userData))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.service.ts